export const i18nMonitoringPage = {
  statusSummary: {
    status: {
      'open-critical': 'Open critical',
      'open-non-critical': 'Open non critical',
      closed: 'Closed',
      late: 'Late',
      open: 'Open',
      alarming: 'Alarming',
      no_alarms: 'No alarms',
      not_found: 'Not found',
    },
  },
  aside: {
    sensors: {
      title: 'Sensors',
      status: { ACTIVE: 'Active', DELAYED: 'Delay', NO_DATA: 'No Data', ALL: 'All status' },
      tooltip: {
        reference: 'Sensor Tag',
        hi: 'Hi',
        hihi: 'Hi Hi',
        low: 'Lo',
        lo: 'Lo',
        lowlow: 'Lo Lo',
        lolo: 'Lo Lo',
        maximum: 'Max',
        minimum: 'Min',
        'pre-alarm hi': 'Pre-alarm Hi',
        'pre-alarm lo': 'Pre-alarm Lo',
        tag: 'Tag',
        target: 'Target',
        subproperties: 'Subproperties',
        editButton: 'Edit',
      },

      validation_errors: {
        Float: 'Only numbers are allowed.',
        Integer: 'Only integer numbers are allowed.',
        Text: 'Only text is allowed.',
      },
    },
    features: {
      title: 'Features',
    },
    chart: 'Chart',
    link: 'Link',
    noData: 'No data found for this section',
    equipmentData: { title: 'Equipment Data' },
    operational: { title: 'Operational' },
    documents: { title: 'Documents' },
  },
  tables: {
    filters: {
      search: 'Search',
      preventive: { 'non-preventive': 'Non-preventives', preventive: 'Preventive', all: 'All' },
      dateOptions: {
        180: 'Last 180 days',
        365: 'Last 365 days',
        730: 'Last 730 days',
        1825: 'Last 1825 days',
      },
    },

    tabsLabels: {
      SAP_NOTES: 'Maint. notes',
      MAINTENANCE_PLAN: 'Maint. plans',
      OIL_ANALYSIS: 'Oil analysis',
      VIBRATION_ANALYSIS: 'Vibration analysis',
      undefined: 'Notes',
      CONDITION_DEVIATION: 'Condition deviations',
      SIMILAR_ALARMS: 'Alarms',
      Empty: '',
      CASES: 'Cases',
      UPLOAD: 'Upload',
    },
    columns: {
      SAP_NOTES: {
        description: 'Description',
        notification_text: 'Code',
        start_date: 'Start',
        end_date: 'End',
        type: 'Type',
        priority: 'Priority',
        link: 'Link',
        status: '',
      },
      MAINTENANCE_PLAN: {
        description: 'Description',
        code: 'Code',
        group: 'Group',
        group_counter: 'Group freq.',
        end_date: 'Due date',
        notes: 'Notes',
        item_id: 'Main item',
        priority: 'Priority',
        status: '',
      },
      OIL_ANALYSIS: { description: 'Analysis' },
      VIBRATION_ANALYSIS: { id: 'Tag' },
      ALARM_HISTORY: {
        severity: 'Sever.',
        description: 'Description',
        start_date: 'Start',
        end_date: 'End',
        tags: 'Tags',
        status: 'Status',
        classification: 'Classification',
        noData: 'Not Classified',
      },
    },
    vibrationAnalysisStatus: {
      Normal: 'Normal',
      Observation: 'Observ',
      Critical: 'Critical',
      Alert: 'Observ',
      noData: '-',
    },
    messages: {
      no_data: {
        SAP_NOTES: 'No maintenance notes to show',
        MAINTENANCE_PLAN: 'No maintenance plans to show',
        OIL_ANALYSIS: 'No oil analysis to show',
        VIBRATION_ANALYSIS: 'No vibration analysis to show',
        CONDITION_DEVIATION: 'No condition deviations to show',
        SIMILAR_ALARMS: 'No alarms to show',
        Empty: 'No data to show',
      },
      saving: 'Saving',
      addEvidence: 'Add Evidences',
      selectAtLeastOne: 'It is necessary to select the evidence in the table',
    },
  },
  models: {
    tabs: { models: 'Models', scaling_models: 'Process Models' },
    links: { fmea: 'FMEA', PI: 'Pi Vision' },
    noData: 'No models for this asset or with this filters',

    noDataForFilter: 'No models found with this status',
  },
  summary: {
    title: 'Summary',
    manufacturer: 'Manufacturer',
    model: 'Model',
    status: 'Status',
    days: 'Days',
    currentStatus: 'In current status',
    ableToOperate: 'Able to operate',
    unableToOperate: 'Unable to operate',
    on: 'ON',
    off: 'OFF',
    stopped: 'Stopped',
    running: 'Running',
    unknown: 'Unknown',
    new: 'New',
    health: 'Health',
    alarms: {
      title: 'Alarms',
      status: {
        OPEN: 'Open',
        CLOSED: 'Closed',
      },
    },
    deviation: {
      title: 'Cond. Dev.',
      status: {
        COMPLETED: 'Completed',
        INVESTIGATING: 'Investigating',
        ACTION_ISSUED: 'Action Issued',
        CANCELED: 'Canceled',
      },
    },
    sensors: {
      title: 'Sensors',
      status: {
        ACTIVE: 'Active',
        DELAYED: 'Delay',
        NO_DATA: 'No Data',
      },
    },
  },

  charts: {
    tabsNames: {
      sensors: 'Sensors',
      charts: 'Charts',
      features: 'Data variables',
      radarView: 'Radar and Plot view',
    },
    noVariables: 'Select one or more variables or sensors above to display the chart',
    updated: 'Updated every 3 seconds',
    filters: {
      dateOptions: {
        1: 'Last 1 hour',
        6: 'Last 6 hours',
        24: 'Last 24 hours',
        7: 'Last 7 days',
        30: 'Last 30 days',
        60: 'Last 60 days',
        90: 'Last 90 days',
        180: 'Last 180 days',
        365: 'Last 365 days',
      },
    },
    labels: {
      switch: 'Exclude data gaps',
    },
  },
};
